<template>
    <modal class="hqcexCouponspayModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">{{choicePayType?.PAY_NAME||"华侨城二消券核销"}}<span class="close" @click="hide()">×</span></div>
        <div ref="code">
            <div class="The-head">
                请输入或扫码：
                <div class="from-input" >
                    <i v-if="$webBrowser?.isMobile?.Android" class="iconfont icon-a-saoma13x" @click="scanCode"></i>
                    <i v-else class="iconfont icon-a-saoma13x"></i>
                    <input-pattern type="text" ref="input" class="key-focus" data-model='idCode' :isBarcode='true' :barcodeLeng="15" v-model="idCode" 
                        @barcode="readCard(true)"
                        @keyup.enter="readCard()" />
                </div>
                <button class="btn" @click="readCard()">查询</button>
                
            </div>
            <div class="modal-body">
                <div class="clearfix">
                    <div class="left-box">
                        <div class="panel">
                            <div class="panel-heading">券列表</div>
                            <div class="panel-body item-box clearfix" v-scroll-anime="{up:'left-order-up',down:'left-order-down',liClass:'.item-li',isRow:false}">
                                <div class="item-li coupons" :class="{selected:item.newCoupon_Id==selectCoupon?.newCoupon_Id}" @click="onTicket(item)"
                                    v-for="item in ticketInfos" :key="item">
                                    <div class="coupons-name">
                                        <div class="coupon-left">
                                            <div class="left-txt">
                                                <span class="m">¥</span>
                                                <span class="y">{{item.Coupon_Amount}}</span>
                                            </div>
                                        </div>
                                        <div class="coupon-right">
                                            <div class="coupon-top">
                                                <div class="tk-txt nowrap">{{item.Coupon_Name}}</div>
                                                <div class="tk-time">{{item.Coupon_Code}}</div>
                                                <div class="tk-time">有效期:{{new Date(item.Start_Time).Format("yyyy-MM-dd")}}至{{new Date(item.End_Time).Format("yyyy-MM-dd")}}</div>
                                            </div>
                                            <div class="cou-ge"></div>
                                            <div class="coupon-bottom">
                                                <span class="bnt-more" :class="{selected:item.extendShow}" @click="item.extendShow=!item.extendShow">详细信息</span>
                                            </div>
                                            <div class="extend" v-show="item.extendShow">
                                                <div v-show="item.Consume_MinMoney>0">使用说明</div>
                                                <div class="ex-span" v-show="item.Consume_MinMoney>0" >消费满{{item.Consume_MinMoney}}元可使用此券</div>
                                            </div>
                                            <i class="iconfont icon-gou-fine"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item-operation">
                                <div class="float-right">
                                    <div class="bnt-fangxiang" ref="left-order-up"><i class="iconfont icon-fangxiang-up"></i></div>
                                    <div class="bnt-fangxiang" ref="left-order-down"><i class="iconfont icon-fangxiang-down"></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="keyboard">
                            <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                                    data-value="9">9</span></div>
                            <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                                    data-value="6">6</span></div>
                            <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                                    data-value="3">3</span></div>
                            <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                                    data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
                        </div>
                        <div class="box-bottom">
                            <div><span class="btm-span">待支付金额:</span>
                                <span class="btm-span-money">
                                    {{invoMoney}}
                                </span>
                            </div>
                            <div class="tick-div"><span class="tick-span">券抵扣:</span><span class="tick-money">{{Number(this.tickDeduMoney).toFixed(2)}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-border" @click="select()" v-throttle>重新查询核销结果</button>
            <button class="btn btn-confirm" @click="confirm()" v-throttle>确定</button>
        </div>
    </modal>
</template>
<script>

import { initKeyBoard,submitting} from '/src/common' 
import { newGuid } from '/src/common/index.js'

//华侨城二消券核销
export default {
    name:"hqcexCouponspayModel",
    emits:["close"],
    props:{
        isShow:Boolean,
        unionEatAutoID:Object,
        //支付类型
        choicePayType:Object,
        unionType:Boolean,
        orderMenuList:Object,
        //订单头信息
        headingInfo:Object,
        //待支付金额
        unPaidMoney:Number,
        RoomAutoID:String,
        DeskName:String,
        //单据id
        EatAutoID:String,
        //单据时间戳
        Timestamps:String,
        //尾数调整金额
        MantissaMoney:Number,
        Channellike:String,
        //支付预览用会员信息
        member:{
            type:Object,
            default:null
        }
    },
    data(){
        return {
            idCode:'',
            /**券数据 */
            ticketInfos:[],
            /**选中的券 */
            selectCoupon:[],
            /**菜品信息 */
            posFoodData:'',
            //mobleChecke:false,
            /**保存订单支付返回记录 */
            payPreviewData:'',
            /**交易记录 */
            Payments:[],
            /**临时订单数据 */
            memberorderInfo:'',  
            userInfo:'', //登录用户
            //记录时间戳
            tmpTimestamps:''
        }
    },
    mounted(){
        //菜品数据结构
        this.$cacheData.PosFoods().then((d)=>{
            this.posFoodData = d.data
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
        })
        this.$nextTick(()=> {
           initKeyBoard.call(this,this.$refs.code);
        })
        this.init();
    }, 
    computed:{
        /*券抵扣金额*/
        tickDeduMoney(){
            let tickDeduMoney=0;
            if(this.selectCoupon){
                if(this.selectCoupon.Exchange_Num){
                    tickDeduMoney=Number(this.selectCoupon.deDuMoney * this.selectCoupon.Exchange_Num);
                }else{
                    tickDeduMoney=Number(this.selectCoupon.deDuMoney);
                }
            }
            return tickDeduMoney;
        },
        //结账金额
        invoMoney(){
            let invoMoney=Number(this.unPaidMoney).compute(-this.tickDeduMoney);
            if(invoMoney<0){
                invoMoney = 0;
            }
            return invoMoney;
        }
    },
    watch: {
        isShow(newVal) {
            if(newVal){
                this.init();
            }
        }
    },
    methods:{
        /**安卓 扫码 */
		scanCode() {
			if (window.webview) {
				this.$webBrowser.hasCamera().then((isQr) => {
					if (isQr == "1") {
						this.$webBrowser.qr().then((d) => {
							this.idCode=d;
                            this.readCard(true);
						}).catch((e) => {
							this.$message({ message: "扫码失败:" + e, type: "warning" });
						});
					} 
				});
			} 
		},
        init(){
            this.idCode='';
            this.ticketInfos=[];
            this.Payments=[];
            this.payPreviewData='';
            this.selectCoupon=null;
            this.memberorderInfo = JSON.parse(JSON.stringify(this.orderMenuList));
            this.memberorderInfo.sort(this.compare('Eat_CheckPrice',''));//按金额从大到小排序
            this.userInfo=this.$auth.getUserInfo();
            this.tmpTimestamps=this.Timestamps;
            setTimeout(() => {
                this.$refs.input.focus();
            },100);
        },
        //重新查询核销结果
        select(){
            if(this.EatAutoID==''){
                this.$message.warning('没有需要查询的支付结果');
                return
            }
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let param={
                User_ID:this.userInfo?.User_ID,  //用户id
                Eat_AutoID:this.EatAutoID, //结账单ID
                Operator_Name:this.userInfo?.Login_Name, //操作员
                Operate_EquipmentID:this.userInfo?.Default_ChannelID, //设备id
                Pos_StationName:this.userInfo?.Site_Name, //站点名称
                Timestamps:this.tmpTimestamps, //账单时间戳
            }
            const loading = this.$loading({
                text: "查询支付结果中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
            });
            console.log(param)
            this.$httpAES.post("Bestech.CloudPos.RequeryThePaymentResult",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                    if(data.ResponseBody?.Timestamps){
                        this.tmpTimestamps = data.ResponseBody.Timestamps.toString();
                        this.$emit("setTimestamps",this.tmpTimestamps)
                    }
                }else{
                    if(data.ResponseHeader.ResultDesc){
                        this.$message.success({ message:data.ResponseHeader.ResultDesc});
                    }
                    if(data.ResponseBody?.Timestamps){
                        this.tmpTimestamps = data.ResponseBody.Timestamps.toString();
                        this.$emit("setTimestamps",this.tmpTimestamps)
                    }
                    return;
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        readCard(isScanCode){
            if(!this.idCode){
                this.$message.warning('查询码不能为空');
                return
            }

            let orderInfo={
                Order_Amount:this.unPaidMoney,//待支付金额
                Mobile:"",
                Order_Time:new Date(),
                OrderConsumes:this.memberorderInfo?.map(it=>{
                    return {
                        Food_ID:it.EAT_XFBMID,
                        Food_Code:it.EAT_XFCode,
                        Food_Name:it.EAT_XFName,
                        Food_Number:it.Eat_Number,
                        Food_CheckPrice:it.Eat_CheckPrice,
                        Food_CheckMoney:it.Eat_CheckPrice*it.Eat_Number
                    }
                })
            };
            //获取平台券信息
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID,
                Platform_Type:7, //平台类型 7:OTM二消券
                Dynamic_Code:this.idCode,
                Dynamic_Type:isScanCode?'activecode':'couponcode',//查询码类型 couponcode:券码，activecode：动态扫码 ，
                OrderInfo:orderInfo,//订单信息
            }
            const loading = this.$loading({
                text: "获取券信息中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CouponPlatform.GetCouponInfo",param).then((data)=>{
                console.log(data);
                loading.close();
                this.$refs.input?.focus();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc)
                }else{
                    this.ticketInfos = data?.ResponseBody||[];
                    this.selectCoupon=null;
                    this.ticketInfos?.forEach(tick=>{
                        Object.assign(tick,{extendShow:false,deDuMoney:0,newCoupon_Id:newGuid()})
                    })
                    if(this.memberorderInfo){
                        this.memberorderInfo.forEach((order)=>{
                            Object.assign(order,{isCoupon:false,CouponNumber:0})
                        })
                    }
                    this.memberorderInfo.sort(this.compare('Eat_CheckPrice',''));
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        //关闭
        hide(){
            this.$emit("close")
        },
        //点击券
        onTicket(item){//单选券
            if(item.newCoupon_Id==this.selectCoupon?.newCoupon_Id){
                this.selectCoupon=null;
            }else{
                //券的最低消费额，0 不限制
                if(item.Consume_MinMoney!=0){
                    if(this.unPaidMoney<item.Consume_MinMoney){
                        this.$message.warning('账单未达到使用该券的金额!');
                        return
                    }
                }
                //时间段控制 0所有时段,1指定时段
                let date = new Date((new Date()).Format("yyyy-MM-dd 00:00:00")); //当前时间 只用年月日判断
                let Start_Time=new Date((new Date(item.Start_Time)).Format("yyyy-MM-dd 00:00:00"));
                let End_Time=new Date((new Date(item.End_Time)).Format("yyyy-MM-dd 00:00:00"));
                if(Start_Time>date || date > End_Time){
                    this.$message.warning('不在该券可使用的时间范围内!');
                    return
                }
                //1.代金券
                if(item.Coupon_Type==1){
                    item.Check=true;
                    if(this.unPaidMoney>item.Coupon_Amount){
                        item.deDuMoney = item.Coupon_Amount;
                    }else{
                        item.deDuMoney = this.unPaidMoney;
                    }
                    this.CoupondeduMoney(item,'','');
                }else if(item.Coupon_Type==2){//2.折扣价
                    item.Check=true;
                    item.deDuMoney= Number(this.unPaidMoney).compute(-Number(this.unPaidMoney).compute(item.Discount_Rate / 100,'*').toFixed(2));
                    if(item.deDuMoney<0){//抵扣金额必须大于0，
                        item.deDuMoney=0;
                    }
                    this.CoupondeduMoney(item,'','')
                }else if(item.Coupon_Type==3){//3.商品券
                    //FoodRange_Type适用类型 1:通用券，所有商品适用，2:部分商品券
                    if(item.FoodRange_Type==1){
                        this.memberorderInfo.some(order=>{
                            //排除口味要求和赠送的菜品
                            if(!order?.is_taste && !order?.Is_Gift){
                                if(order.isCoupon==false && order.Eat_Number>0 && order.Eat_Number>order.Exchanged_Number){
                                    if(item.Food_Weight==0){
                                        item.deDuMoney = Number(order.Eat_CheckPrice);
                                        this.CoupondeduMoney(item,order,'')
                                        if(order.CouponNumber==0 || order.CouponNumber<order.Eat_Number){
                                            order.CouponNumber += 1
                                        }
                                        return true
                                    }else{
                                        let _weight=this.commWeight(item,order)
                                        item.deDuMoney = Number(order.Eat_CheckPrice);
                                        this.CoupondeduMoney(item,order,_weight)
                                        if(order.CouponNumber==0 || order.CouponNumber<order.Eat_Number){
                                            order.CouponNumber += _weight;
                                        }
                                        return true
                                    }
                                }
                            }
                        })
                    }else if(item.FoodRange_Type==2){
                        let title =''
                        let _types = 0
                        this.memberorderInfo.some(order=>{
                            if(order.isCoupon==false && !order?.Is_Gift && !order?.is_taste){
                                if(item.Exchange_FoodCodes.indexOf(order.EAT_XFCode)!=-1 && order.Eat_Number>0 && order.Eat_Number>order.Exchanged_Number){
                                    if(item.Food_Weight==0){
                                        _types=1
                                        item.deDuMoney = Number(order.Eat_CheckPrice);
                                        if(order.CouponNumber==0 || order.CouponNumber<order.Eat_Number){
                                            order.CouponNumber += 1;
                                        }
                                        this.CoupondeduMoney(item,order,'');
                                    }else{
                                        _types=1
                                        let _weight=this.commWeight(item,order);
                                        item.deDuMoney = Number(order.Eat_CheckPrice);
                                        if(order.CouponNumber==0 || order.CouponNumber<order.Eat_Number){
                                            order.CouponNumber += _weight;
                                        }
                                        this.CoupondeduMoney(item,order,_weight)
                                    }
                                    
                                }else{
                                    if(order.Eat_Number<=order.Exchanged_Number){
                                        title = '该券对应的菜品已使用过券,已不满足条件'
                                    }else{
                                        title = '未找到编号'+item.Exchange_FoodCodes+'的菜品'
                                    }
                                }
                                if(_types==1){
                                    return true
                                }
                            }
                        })
                        if(_types==0){
                            if(title==''){
                                title='没有满足条件的菜品'
                            }
                            this.$message.warning(title);
                            return
                        }
                    }
                }
            }
        },
        //商品券兑换商品重量(单位：斤），0 不限制
        commWeight(item,order){
            if(item.Food_Weight>=order.Eat_Number){
                return order.Eat_Number
            }else if(item.Food_Weight<=order.Eat_Number-order.Exchanged_Number){
                return item.Food_Weight
            }else if(item.Food_Weight>order.Eat_Number-order.Exchanged_Number){
                return Number(Number(order.Eat_Number-order.Exchanged_Number).toFixed(2))
            }
        },
        //deduMoney变动
        CoupondeduMoney(item,order,weight){
            this.selectCoupon= JSON.parse(JSON.stringify(item));
            let sele=this.selectCoupon;
            if(!sele?.ConsumeID){
                if(order){
                    if(item.Food_Weight!=0){
                        Object.assign(sele,{ConsumeID:order.Eat_ConsumeID,Exchange_Num:weight})
                    }else{
                        let _num=0
                        if(order.Exchanged_Number!=0){
                            if(order.Eat_Number-order.Exchanged_Number>1){
                                _num=1
                            }else{
                                _num = order.Eat_Number-order.Exchanged_Number
                            }
                        }else{
                            if(order.Eat_Number<1){
                                _num = order.Eat_Number
                            }else{
                                _num = 1
                            }
                        }
                        Object.assign(sele,{ConsumeID:order.Eat_ConsumeID,Exchange_Num:_num})
                    }
                }else{
                    Object.assign(sele,{Exchange_Num:1})
                }
            }
        },
        //确定支付
        confirm:submitting(function(event){
            if(!this.selectCoupon){
                this.$message.warning('请先选择优惠券!');
                return
            }
            /**支付方式 */
            let tick=this.selectCoupon;//单个券
            let _choice={
                Coupon_AutoId:tick.Coupon_TemplateId,
                Coupon_Code:tick.Coupon_Code,
                Coupon_Name:tick.Coupon_Name,
                Coupon_Kind:tick.Coupon_Type,
                Coupon_Num:1,
                Coupon_CostPrice:tick.Merchant_FactAmount,
                Exchange_ConsumeID:tick?.ConsumeID,
                Exchange_Num:tick?.Exchange_Num,
                Coupon_VerifyToken:tick.Coupon_VerifyToken,
                Scene_Type:1,
                External_UserId:tick?.External_UserId,
                Customer_Mobile:tick?.Customer_Mobile,
                Channel_ID:tick?.Channel_ID
            }
           
            let _payment=[{
                Payment_ID:this.choicePayType.PAY_ID,  //支付方式ID
                Payment_Code:this.choicePayType.PAY_CODE, //支付方式编号
                Payment_Name:this.choicePayType.PAY_NAME, //支付方式名称
                Payment_Type:this.choicePayType.INTERFACE_TYPE, //支付方式类型
                Payment_Money: tick.deDuMoney, //支付金额
                OverCharge_Money:0,  //多收金额
                Payment_FactMoney:0, //计营业额
                Qr_Code:'', //扫码付款的码值
                Card_No:'', //卡号
                CouponInfo:_choice, //券的详情
            }];
            let itemList=JSON.parse(JSON.stringify(this.orderMenuList));
            if(tick.Coupon_Type==3){//3.商品券
                itemList.some(it=>{
                    if(tick.ConsumeID==it.Eat_ConsumeID){//抵扣的商品
                        it.CouponCodes=[tick.Coupon_Code];
                        return true;
                    }
                })
            }

            let _orderConsumes=this.$global.getFastOrderConsumes(itemList);
            
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID,  //用户id
                Eat_AutoID:'', //订单ID，当异常单重新处理时需要传入
                Timestamps:'',//订单单时间戳，当异常单重新处理时需要传入
                Operator_Name:this.userInfo?.Login_Name, //操作员
                Eat_PersonNum:this.headingInfo?.DinersNum,//人数
                Channel_ID:this.Channellike,//订单渠道ID
                Room_ID:this.RoomAutoID,//餐厅ID
                Eat_DeskID:this.headingInfo?.DeskAutoID, //桌台ID
                Eat_DeskName:this.DeskName, //桌台名称
                Eat_TakeNo:this.headingInfo?.brandNumber,//牌号
                Eat_AllRemark:'', //订单全单备注
                Order_Remark:this.headingInfo.orderRemark,//订单备注
                Order_BatchNo:newGuid(),//下单批次号，每次提交下单，调用方生成一个唯一批次号，接口判断防止重复下单
                NotSendToKitPrint:false, //下单不送打厨房
                ElectronicInvoice_PrintForbidden:this.$global.isNoPrintInvoice,//是否选择禁止打印发票二维码 false: 默认打印发票二维码,true: 不打印发票二维码
                MantissaAdjustment_Money: Number(Number(this.MantissaMoney).toFixed(2)),//尾数调整金额
                Member:this.member,//会员信息
                OrderConsumes:_orderConsumes, //订单消费详细
                Payments:_payment//支付方式
            }
            //当异常单重新处理时需要传入
            if(this.EatAutoID){
                param.Eat_AutoID=this.EatAutoID
                if(this.tmpTimestamps){
                    param.Timestamps=this.tmpTimestamps;
                }
            }
            /**支付预览 */
            const loading = event.loading({
                text: "支付预览中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            console.log('支付预览 param:',param)
            this.$httpAES.post("Bestech.CloudPos.SnackPayPreview",param).then((data)=>{
                loading.close();
                console.log('支付预览 data:',data)
                
                
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                    if(data.ResponseBody?.Eat_AutoID!=undefined && data.ResponseBody?.Eat_AutoID!=null){
                        this.$parentEmit('updateOrder',data.ResponseBody);
                    }
                }else{
                    if(data.ResponseBody?.OpenCashBox==true){
                        this.$webBrowser.openCashBoxBnt().then(d=>{
                            if(d?.state!=0){
                                this.$message.error('钱箱打开失败:'+(d?.message||""));
                            }
                        });
                    }
                    /**Is_NeedSMSCode：是否需要短信验证码0不需要1需要 */
                    if(data.ResponseBody.Is_NeedSMSCode==1){
                        console.log('短信验证')
                    }
                    /**Is_NeedPassWord：是否需要密码验证0不需要1需要 */
                    if(data.ResponseBody.Is_NeedPassWord==1){
                        console.log('密码验证')
                    }
                    /**支付提交判断 0不需要 1需要 */
                    if(data.ResponseBody.Is_NeedSubmit==1){
                        this.PaySubmit(data)
                    }else{
                        if(data.ResponseBody?.PrintsInfo){
                            setTimeout(()=>{
                                this.$webBrowser.posPrint(data.ResponseBody.PrintsInfo);
                            },100);
                        }
                        this.$emit('subMultipleConfirm',data.ResponseBody,[this.selectCoupon]);
                    }
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        }),
        /**支付提交接口 */
        PaySubmit:submitting(function(event,data){
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID, //登陆用户ID
                Eat_AutoID: data.ResponseBody?.Eat_AutoID,//结账单ID
                Member_Type:data.ResponseBody?.Member_Type,  //会员类型
                Biz_ID:data.ResponseBody?.Biz_ID, //业务交易流
                MantissaAdjustMoney:data.ResponseBody?.MantissaAdjustMoney,//尾数调整金额
                Verify_Code:'', //验证码
                Operator_Name:this.userInfo?.Login_Name, //操作员
                ElectronicInvoice_PrintForbidden:this.$global.isNoPrintInvoice,//是否选择禁止打印发票二维码 false: 默认打印发票二维码,true: 不打印发票二维码
                Timestamps:data.ResponseBody.Timestamps.toString(),
                Payments:data.ResponseBody.Payments
            }
            /**支付提交 */
            const loading = event.loading({
                text: "支付提交中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.SnackPaySubmit",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                }else{
                    if(data.ResponseBody.IsMultipleCardPay==false){
                        this.Payments = this.Payments.concat(data.ResponseBody.Payments)
                        this.isPaySubmit =1
                        if(data.ResponseBody?.PrintsInfo){
                            setTimeout(()=>{
                                this.$webBrowser.posPrint(data.ResponseBody.PrintsInfo);
                            },100);
                        }
                        if(data.ResponseBody?.OpenCashBox==true){
                            this.$webBrowser.openCashBoxBnt().then(d=>{
                                if(d?.state!=0){
                                    this.$message.error('钱箱打开失败:'+(d?.message||""));
                                }
                            });
                        }
                        this.$message.success({ message: "支付完成"});
                        this.$emit('submiConfirm')
                    }else{
                        if(data.ResponseBody.IsMultipleCardPay==true){
                            this.$emit('subMultipleConfirm',data.ResponseBody);
                        }
                    }
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        }),
        /**数组排序 */
        compare(attr,Time) {
            return function(a,b){
                var val1 = a[attr];
                var val2 = b[attr];
                var Times1 = a[Time];
                var Times2 = b[Time];
                return val2 - val1 || Times1 - Times2;
            }
        }
    }
}
</script>

<style lang="sass">
@import "./hqcexCouponspayModel.scss";
</style>